import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBlockTrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.77 5.25h10.46l3.555 5.17L12 19.545 3.215 10.42 6.769 5.25Zm11.25-1.5H5.98l-4.695 6.83L12 21.705 22.715 10.58 18.019 3.75Z"
    />
    <path
      fill="#F7A600"
      d="m7.345 10.655 1.06-1.06L12 13.189l3.595-3.594 1.06 1.06L12 15.311l-4.655-4.656Z"
    />
  </svg>
);
export default SvgTwoColorBlockTrade;
